/**
 * Created by Oleg on 28.02.2020.
 */

const SubscriptionInfo = cleverapps.Layout.extend({
    ctor: function () {
        const styles = cleverapps.styles.SubscriptionInfo;
        const content = cleverapps.UI.generateOnlyText(Messages.get("SubscriptionWindow.MainText"), cleverapps.styles.FONTS.SUBSCRIPTION_MAIN_TEXT);
        content.setDimensions(cleverapps.styles.SubscriptionWindow.width, 0);
        content.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        let gift;

        if (cleverapps.clans && Clans.IsAvailable()) {
            const icon = new cc.Sprite(bundles.subscription_window.frames.clan_gift_png);

            gift = new TextWithIcon(`** ${Messages.get("ClanGift.Text")}`, {
                font: cleverapps.styles.FONTS.SUBSCRIPTION_MAIN_TEXT,
                icons: {
                    "**": icon
                },
                iconMaxHeight: 2
            });
        }

        this._super([content, gift].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });
    }
});

cleverapps.styles.SubscriptionInfo = {
    margin: 15,
    padding: {
        x: 0,
        y: 10
    }
};